import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import Header from "../components/Header";
function Updates() {
  return (
    <div className="container">
      <Header />
      <div className="center col container" style={{ marginTop: "4%" }}>
        <Typography variant="h4">Updates and logs</Typography>
        <table className="table table-hover">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <Typography variant="h5">Versions </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">Date </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h5">Details </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Template
                <TableRow>
                  <TableCell><Typography variant="h6" align="left"></Typography></TableCell>
                  <TableCell algin="right"><Typography variant="h6"></Typography></TableCell>
                  <TableCell algin="right"><Typography variant="h6"></Typography></TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell>
                    <Typography variant="h6" align="left">
                      2.0
                    </Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">6/29</Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">
                      Added detailed pokemon page, 404 page and changed pokedex
                      image to official artwork
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="h6" align="left">
                      1.2
                    </Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">6/24 </Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">
                      Added pokedex, update page and more detailed information
                      to search.
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    <Typography variant="h6">1.0</Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">6/20</Typography>
                  </TableCell>
                  <TableCell algin="right">
                    <Typography variant="h6">
                      Added Search bar and made basic components for this app.
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </table>
      </div>
    </div>
  );
}

export default Updates;
